<template>
  <div>
    <div class="vform-label white mt-4">{{ $t('Selected') }}</div>
    <div v-if="!metaSetsWithSelectedFields.length">
      -
    </div>
    <div
        v-for="metaSet in metaSetsWithSelectedFields"
        :key="metaSet.id + 'selectedset' + forceReRenderKey"
        class="metaSet"
    >
      <div class="lighter selected-field-faker">
        {{ metaSet.name }}
        <div
            class="d-inline-block float-right"
            @click="removeItemsFromSelection(getSelectedMetaFieldsForMetaSet(metaSet.id).map(x => x.id))">
          <icon class="clickable" size="1" type="square-minus"/>
        </div>
      </div>
      <div
          v-for="field in getSelectedMetaFieldsForMetaSet(metaSet.id)"
          :key="field.id + 'selected' + forceReRenderKey"
          class="d-flex justify-content-between mt-1 selected-field"
      >
        <div>
          {{ field.key }}
        </div>
        <div class="clickable" @click="removeItemsFromSelection([field.id])">
          <icon size="1" type="square-minus"/>
        </div>
      </div>
    </div>

    <div class="lighter mt-4 smaller">Select fields to display</div>
    <div class="vform-label white">{{ $t('MetaSets') }}</div>
    <drop-down
        :initial-active-value="selectedMetaSet"
        :labels="metaSetLabels"
        :values="metaSetValues"
        class="language-selector mt-2 mb-1"
        @select="setSelectedMetaSet"
    />

    <div class="vform-label white mt-2">{{ $t('MetaFields') }}</div>
    <div class="selectable-field-faker text-right">
      <div
          v-if="getUnselectedMetaFieldsForMetaSet(selectedMetaSet).length > 1"
          class="d-inline-block"
          @click="addItemsToSelection(getUnselectedMetaFieldsForMetaSet(selectedMetaSet).map(x => x.id))"
      >
        <icon size="1" type="square-plus"/>
      </div>
    </div>
    <div v-if="!getUnselectedMetaFieldsForMetaSet(selectedMetaSet).length">
      {{ selectedMetaSet ? $t('noMoreMetaFieldsToAdd') : '-' }}
    </div>
    <div
        v-for="item in getUnselectedMetaFieldsForMetaSet(selectedMetaSet)"
        :key="item.id"
        class="d-flex justify-content-between mt-1 selectable-field"
        @click="addItemsToSelection([item.id])"
    >
      <div @click="$emit('updateMetaFieldSelection', item.id)">
        {{ item.key }}
      </div>
      <div class="clickable">
        <icon size="1" type="square-plus"/>
      </div>
    </div>


  </div>
</template>

<script>
import DropDown from "@/components/forms/DropDown.vue";
import Icon from "@/components/Icon";

export default {
  name: "MetaFieldsSelection",
  components: {DropDown, Icon},
  props: {
    organizationId: {
      type: String,
      required: true
    },
    selectedMetaFields: {
      type: Array,
      default: () => []
    },
    includeSuperOrgMetasets: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      metaSets: [],
      selectedMetaSet: null,
      forceReRenderKey: 0
    }
  },
  computed: {
    metaSetLabels() {
      return this.metaSets.map((ms) => ms.name);
    },
    metaSetValues() {
      return this.metaSets.map((ms) => ms.id);
    },
    metaSetsWithSelectedFields() {
      return this.metaSets.filter((ms) => {
        return ms.metaFields.some((mf) => this.selectedMetaFields.includes(mf.id));
      });
    }
  },
  beforeMount() {
    this.loadMetaSets();
  },
  methods: {
    getMetaFieldById(metaFieldId) {
      for (const metaSet of this.metaSets) {
        const metaField = metaSet.metaFields.find((mf) => mf.id === metaFieldId);
        if (metaField) return metaField.key;
      }
      return null;
    },
    getSelectedMetaFieldsForMetaSet(metaSetId) {
      const metaSet = this.metaSets.find((ms) => ms.id === metaSetId);
      if (!metaSet) return [];
      return metaSet.metaFields.filter((mf) => this.selectedMetaFields.includes(mf.id));
    },
    getUnselectedMetaFieldsForMetaSet(metaSetId) {
      const metaSet = this.metaSets.find((ms) => ms.id === metaSetId);
      if (!metaSet) return [];
      return metaSet.metaFields.filter((mf) => !this.selectedMetaFields.includes(mf.id));
    },
    setSelectedMetaSet(value) {
      this.selectedMetaSet = value;
    },
    addItemsToSelection(metaFieldIds) {
      let newSelection = [...this.selectedMetaFields];
      for (const metaFieldId of metaFieldIds) {
        if (!newSelection.includes(metaFieldId)) {
          newSelection.push(metaFieldId);
        }
      }
      this.$emit('updateMetaFieldSelection', newSelection);
      this.forceReRenderKey++;
    },
    removeItemsFromSelection(metaFieldIds) {
      let newSelection = [...this.selectedMetaFields];
      for (const metaFieldId of metaFieldIds) {
        newSelection = newSelection.filter(id => id !== metaFieldId);
      }
      this.$emit('updateMetaFieldSelection', newSelection);
      this.forceReRenderKey++;
    },
    async loadMetaSets() {
      return await this.$store.dispatch('clientLoadMetaSets', {
        include: 'metaFields',
        filter: "organizationId in '" + this.organizationId + "' '" + this.$store.getters.getSuperOrg + "'"
      }).then(metaSets => {
        metaSets = metaSets.filter((ms) => {
          return ms.organizationId === this.organizationId || (this.includeSuperOrgMetasets.find((x) => x === ms.name))
        });
        metaSets.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        this.$set(this, 'metaSets', metaSets);
      })
    },
  }
}
</script>


<style lang="scss" scoped>
.smaller {
  font-size: 0.8rem;
}
.selectable-field {
  background-color: var(--vform-editor-ui-secondary-color);
  border: 1px solid var(--vform-editor-ui-secondary-color);
  cursor: pointer;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 0.9rem;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
}
.selectable-field-faker {
  border: 1px solid transparent;
  padding: 1px 8px;
  font-size: 0.9rem;
}

.selected-field {
  border: 1px solid var(--vform-editor-ui-secondary-color);
  padding: 1px 8px;
  border-radius: 3px;
}
.selected-field-faker {
  border: 1px solid transparent;
  padding: 1px 8px;
}

.metaSet {
  padding: 3px;
  border-radius: 3px;
  padding-bottom: 5px;
  margin-bottom: 3px;
  background-color: rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid var(--vform-editor-ui-secondary-color);
}
</style>